
function toggleLoader(message){  
  $('.hullee-status-loader-message').text(message);
  $('.hullee-status-loader').toggle();
}

function updateLoaderMessage(message){
  $('.hullee-status-loader-message').text(message);
}

function displayReplaceButton(file){
  $(".file-name-display").text(file.name);
  $('#upload-replace-button').css("display", "block");
  $('#upload-drop').css("display", "none");  
}

function togglePreviewMessage(){
  $('.preview-message').toggle();
}

function hidePreviewMessage(){
  $('.preview-message').css("display", "none");
}

function displayPreviewMessage(){
  $('.preview-message').css("display", "block");
}

function getCanvasElement(){
  return $('#preview-canvas').get(0);
}

class Canvas{
  canvasEl = getCanvasElement();
  canvasContext = this.canvasEl.getContext('2d');  
  thumbnailCanvas = document.createElement("canvas");
  thumbContext = this.thumbnailCanvas.getContext('2d');

  constructor(){
    const scale = 1/3;  
    this.thumbnailCanvas.setAttribute('width', `${this.canvasEl.width * scale}`);
    this.thumbnailCanvas.setAttribute('height', `${this.canvasEl.height * scale}`);
  }

  isPortrait(width, height){
    return height > width;
  }

  isLandscape(width, height){
    return width > height;
  }

  toPortrait(){
    $(this.canvasEl).removeClass('landscape-canvas');
    $(this.canvasEl).addClass('portrait-canvas');
  }

  toLandscape(){
    $(this.canvasEl).removeClass('portrait-canvas');
    $(this.canvasEl).addClass('landscape-canvas');
  }

  setCanvasStyle(){
    $(this.canvasEl).css('width', this.canvasEl.width);
    $(this.canvasEl).css('height', this.canvasEl.height);
    const aspectRatio =  this.canvasEl.height > this.canvasEl.width ?
      `1 / ${this.canvasEl.height / this.canvasEl.width}` :
      `${this.canvasEl.width / this.canvasEl.height} / 1`;
    $(this.canvasEl).css('aspect-ratio', aspectRatio);    
  }
  
  rotateCanvas(){    
    const newHeight = this.canvasEl.width;
    this.canvasEl.width = this.canvasEl.height;
    this.canvasEl.height = newHeight;

    const newThumbHeight = this.thumbnailCanvas.width;
    this.thumbnailCanvas.width = this.thumbnailCanvas.height;
    this.thumbnailCanvas.height = newThumbHeight;
  } 

  autoOrientToImage(imageWidth, imageHeight){
    if(this.isPortrait(imageWidth, imageHeight) 
      && !this.isPortrait(this.canvasEl.width, this.canvasEl.height)){
      this.rotateCanvas();
      $('hullee-variant-picker input[value="Portrait"]').trigger('click');
    }else if(this.isLandscape(imageWidth, imageHeight) 
      && !this.isLandscape(this.canvasEl.width, this.canvasEl.height)){      
      this.rotateCanvas();
      $('hullee-variant-picker input[value="Landscape"]').trigger('click');
    }        
    this.setCanvasStyle();
  }

  display(){
    $(this.canvasEl).css("display", "block");
  }

  async getThumbnailFile(){    
    return new Promise((resolve, reject) => {
      this.thumbnailCanvas.toBlob(blob => {
        resolve(new File([blob], "thumbnail.jpg"));
      }, "image/jpeg");        
    });     
  }  

  getThumbDataUrl(){
    return this.thumbnailCanvas.toDataURL("image/jpeg");
  }

  generateThumbnailImage(){    
    const canvasThumb = $(this.canvasEl).clone();
    const scale = 1/3;  
    canvasThumb.attr('width', `${this.canvasEl.width * scale}`);
    canvasThumb.attr('height', `${this.canvasEl.height * scale}`);
    $('.upload-modal-product-details').append(canvasThumb);
  }
}

class PreviewImageViewer{
  canvas = new Canvas();
  file = undefined;
  imageSize = {width: 0, height: 0};

  render(file){
    this.file = file;
    return this.imageSize;
  }

  getCanvas(){
    return this.canvas;
  }

  getUploadedImageSize(){
    return this.imageSize;
  }
}

class ImageViewer extends PreviewImageViewer{
  // size in mm in mininum 72dpi
  getPxToMmInMinDpi(sizePx){
    const minDpi = 72;
    const mmInInch = 25.4;
    return Math.ceil((sizePx * mmInInch) / minDpi);
  }

  // Natural size in mm
  getPxToMm(sizePx){
    const pxInmm = 0.2645833333;
    return sizePx * pxInmm;
  }

  #draw(image){
    this.canvas.canvasContext.clearRect(0, 0, this.canvas.canvasEl.width, this.canvas.canvasEl.height);
    this.canvas.canvasContext.drawImage(image, 0, 0, this.canvas.canvasEl.width, this.canvas.canvasEl.height);    
    this.canvas.display();    
    // Draw the thumbnail
    this.canvas.thumbContext.drawImage(image, 0, 0, this.canvas.thumbnailCanvas.width, this.canvas.thumbnailCanvas.height);        
  }
    
  render(file) {

    return new Promise((resolve, reject) => {
      const imgUrl = URL.createObjectURL(file);
      const image = new Image();
      image.src = imgUrl;      
      image.onload = () => {
        this.imageSize = {width: this.getPxToMmInMinDpi(image.width), height: this.getPxToMmInMinDpi(image.height)};

        // Auto orient Canvas
        this.canvas.autoOrientToImage(this.imageSize.width, this.imageSize.height);
        // Draw the image content to canvas
        this.#draw(image);
        return resolve(this.imageSize);        
      }      
    });
  }

  getCanvas(){
    return this.canvas;
  }
}

class PdfViewer extends PreviewImageViewer {
  // Convert pt to mm
  getPtToMm(sizeInPt) {
    const ptInmm = 0.3527777778;
    return Math.ceil(sizeInPt * ptInmm);
  }

  async render(file) {
    const docUrl = URL.createObjectURL(file);
    const pdf = await window.pdfjsLib.getDocument(docUrl).promise;
    const page = await pdf.getPage(1);
    this.imageSize = {
      width: this.getPtToMm(page.view[2]),
      height: this.getPtToMm(page.view[3]),
    };

    // Auto orient canvas
    this.canvas.autoOrientToImage(this.imageSize.width, this.imageSize.height);

    const viewport = page.getViewport({
      scale: this.canvas.canvasEl.width / page.getViewport({ scale: 1 }).width,
    });
    
    // Draw the pdf content to canvas
    await page.render({ canvasContext: this.canvas.canvasContext, viewport }).promise;    
    this.canvas.display();

    // Redraw the canvas content to thumbnail
    this.canvas.thumbContext.drawImage(this.canvas.canvasEl, 0,0, this.canvas.thumbnailCanvas.width, this.canvas.thumbnailCanvas.height);    

    const pageSize = page.getViewport();
    return Promise.resolve(this.imageSize);
  }

  getCanvas() {
    return this.canvas;
  }
}

const SIZES = [
  { name: 'A5', dimension: [148, 210], autoOrient: true, canvas: [420, 594] }, 
  { name: 'A4', dimension: [210, 297], autoOrient: true, canvas: [420, 594] }, 
  { name: 'A3', dimension: [297, 420], autoOrient: true, canvas: [420, 594] },
  { name: 'A2', dimension: [420, 594], autoOrient: true, canvas: [420, 594] },
  { name: 'A1', dimension: [594, 841], autoOrient: true, canvas: [420, 594] },
  { name: 'A0', dimension: [841, 1189], autoOrient: true, canvas: [420, 594] },
  { name: 'B0', dimension: [1414, 1000], autoOrient: true, canvas: [420, 594] },
  { name: 'B1', dimension: [1000, 707], autoOrient: true, canvas: [420, 594] },
  { name: 'B2', dimension: [707, 514], autoOrient: true, canvas: [420, 594] },
  { name: 'St', dimension: [900, 600], autoOrient: true, canvas: [420, 594] }, 
  { name: 'La', dimension: [1200, 900], autoOrient: true, canvas: [420, 594] },
  { name: '850 x 2000 mm', dimension: [850, 2000], autoOrient: false, canvas: [290, 682] },
  { name: '1000 x 2000 mm', dimension: [1000, 2000], autoOrient: false, canvas: [300, 600] },
  { name: '1200 x 2000 mm', dimension: [1200, 2000], autoOrient: false, canvas: [360, 600] },
  { name: '610 x 1500 mm', dimension: [610, 1500], autoOrient: false, canvas: [279, 686] },
  { name: '1800 x 800 mm', dimension: [1800, 800], autoOrient: true, canvas: [601, 267.111], products: ["Hang Banners"] },
  { name: '1800 x 1000 mm', dimension: [1800, 1000], autoOrient: true, canvas: [600, 333.333], products: ["Hang Banners"] },
  { name: '2000 x 1000 mm', dimension: [2000, 1000], autoOrient: true, canvas: [600, 300], products: ["Hang Banners"] },
  { name: '3000 x 1000 mm', dimension: [3000, 1000], autoOrient: true, canvas: [750, 250], products: ["Hang Banners"] },
  { name: '3000 x 1200 mm', dimension: [3000, 1200], autoOrient: true, canvas: [650, 260], products: ["Hang Banners"] },
  { name: '3000 x 1500 mm', dimension: [3000, 1500], autoOrient: true, canvas: [600, 300], products: ["Hang Banners"] }
];

const FILETYPES = ["PDF", "JPG/JPEG", "PNG", "BMP"];
const DOC_FILETYPES = ['image/jpg', 'image/jpeg', 'image/png', 'image/bmp', 'application/pdf'];
const ORIENTATION = {portrait: 'portrait', landscape: 'landscape'};

// const aspectRatioMin = 1.1; // Ideal aspect ratio is 1.4 
// const aspectRatioMax = 1.7;
function getProductSize(){
  const sizeName = $(".upload-modal-Size-val").text();
  return SIZES.find(size => { 
    const shortName = sizeName.substr(0, 2);
    return size.name === sizeName || size.name === shortName;
  });
}

function getIsAspectRatioOk(productSize, uploadedImageSize){
  const ASPECT_RATIO_TOLERANCE = 0.2;
  const uploadedImageRatio =  uploadedImageSize.width < uploadedImageSize.height ?
    uploadedImageSize.height / uploadedImageSize.width :
    uploadedImageSize.width / uploadedImageSize.height;
  
  const productRatio = productSize.width < productSize.height ?
  productSize.height / productSize.width :
  productSize.width / productSize.height;

  let ratioDiff = productRatio - uploadedImageRatio;
  ratioDiff = ratioDiff < 0 ? ratioDiff * -1 : ratioDiff;  
  return ratioDiff <= ASPECT_RATIO_TOLERANCE;
}

function getPreflightStatus(uploadedImageSize){
  const preflightStatus = {isOk: true};
  const productSizeDetails = getProductSize();
  if(!productSizeDetails){
    console.log('Error: no product size details');
    return preflightStatus; // Skipping preflight
  }
  const productSize = {};
  if(uploadedImageSize.width < uploadedImageSize.height){
    productSize.width = productSizeDetails.dimension[0];
    productSize.height = productSizeDetails.dimension[1];
  }else{
    productSize.width = productSizeDetails.dimension[1];
    productSize.height = productSizeDetails.dimension[0];
  }    

  preflightStatus.isSizeOk = uploadedImageSize.width >= productSize.width;  

  preflightStatus.messages = [];
  if(!preflightStatus.isSizeOk){
    preflightStatus.messages.push(`Failure: Document size is invalid.`);
    preflightStatus.messages.push(`Details: At minimum DPI, your document dimension is only ${uploadedImageSize.width}x${uploadedImageSize.height}mm.`);
    preflightStatus.messages.push(`Recommendation: Size must be ${productSize.width}x${productSize.height}mm.`);
    preflightStatus.isOk = false;
  }
  
  preflightStatus.isAspectRatioOk = getIsAspectRatioOk(productSize, uploadedImageSize);

  if(!preflightStatus.isAspectRatioOk){
    preflightStatus.messages.push(`Failure: Aspect ratio is invalid.`);
    preflightStatus.messages.push(`Details: The aspect ratio does not meet the minimum requirement for your document size at minimum dpi.`);
    preflightStatus.messages.push(`Recommendation: Size must be ${productSize.width}x${productSize.height}mm.`);
    preflightStatus.isOk = false;
  }
  return preflightStatus;
}

async function getUploadPolicy() {
  const policyUrl = "https://upload.pickaprint.com.au/upload-sig";
  // const policyUrl = "http://localhost:8081/upload-sig";
  const response = await fetch(policyUrl);
  if (!response.ok) {
    const errorMsg = await response.text();
    const errorData = { error: "Get policy failed", message: errorMsg };    
    return Promise.resolve(errorMsg);
  }
  return await response.json();
}

async function uploadFile(file, fileId, policy, contentType){  
  const formData = new FormData();    
  formData.append("acl", "public-read");
  formData.append("key", fileId);
  formData.append("x-amz-meta-uuid", policy.guid);
  formData.append("x-amz-meta-tag", file.name);
  formData.append("x-amz-credential", policy.credential);
  formData.append("x-amz-algorithm", "AWS4-HMAC-SHA256");
  formData.append("x-amz-date", policy.date + "T000000Z");
  formData.append("Policy", policy.policy);
  formData.append("X-Amz-Signature", policy.signature);
  formData.append("content-type", contentType);
  formData.append("file", file);

  const response = await fetch('https://pickaprint-upload.s3.amazonaws.com/',{
      method: "POST",
      body: formData      
    });  

  if(response.ok){
    return Promise.resolve( { message: "success" });
  }else{
    const errorMsg = await response.text();
    return Promise.resolve( { error: "Upload file failed", message: errorMsg })
  }
}

async function uploadModalAddToCart(file){
  // Skip if the upload preview canvas was never generated 
  if(!previewCanvas){
    return;
  }  
  $(".upload-modal-window").animate({ scrollTop: 0 }, "slow");
  toggleLoader('Preparing your custom document...');
  const policy = await getUploadPolicy();  
  const fileExt = file.name.substr(file.name.lastIndexOf('.')+1,file.name.length);
  const product_custom_id = `${Date.now()}-${policy.guid}`;
  const fileId = `${product_custom_id}.${fileExt}`;  
  
  // Upload main file
  const mainImage =  await uploadFile(file, fileId, policy, "application/octet-stream");  

  toggleLoader('Generating cart preview...');
  //Upload thumbnail if the preview canvas was generated  
  const product_view_id = `${Date.now()}-${policy.guid}`;
  const thumbFileId = `${product_view_id}_thumb.jpg`;
  const thumbFile = await previewCanvas.getThumbnailFile();  
  const thumbUploadResp = await uploadFile(thumbFile, thumbFileId, policy, "image/jpeg");    

  toggleLoader('Adding to cart...');
  var cartForm = $('form[action="/cart/add"]');  
  $(cartForm).append(`<input type="hidden" name="properties[_product_custom_id]" value="${product_custom_id}">`);
  $(cartForm).append(`<input type="hidden" name="properties[_product_custom_view_id]" value="${product_view_id}">`);
  $(cartForm).append(`<input type="hidden" name="properties[_product_custom_type]" value="customer_upload">`);
  $(cartForm).append(`<input type="hidden" name="properties[_product_custom_file_type]" value="${fileExt}">`);
  $(cartForm).submit();  
}

function displayPreflightMessage(preflightStatus){
  if(preflightStatus.isOk){
      $('#upload-button').removeAttr('disabled');
      hidePreviewMessage();
      return;    
  }
  $('#upload-button').attr("disabled", "disabled");
  $('.preview-message-header').text('Document check failure');  
  let messageStr = "";
  preflightStatus.messages.forEach(msg => {    
    messageStr = messageStr.concat(`<li>${msg}</li>`);
  });  
  $('.preview-message-content').html(`<ul>${messageStr}</ul>`);
  displayPreviewMessage();  
}

function displayFiletypeMessage(file){
  $('.preview-message-header').text('Invalid file type');
  let messageStr = `<span>File: ${file.name}</span> <span>Accepted file types:</span>`; 
  let filetypeHtml = "";
  FILETYPES.forEach(fileType => {
    filetypeHtml = filetypeHtml.concat(`<li>${fileType}</li>`);
  });
  messageStr = messageStr.concat(`<ul>${filetypeHtml}</ul>`);
  $('.preview-message-content').html(messageStr);    
  displayPreviewMessage();  
}

function isValidFileType(file){
  return  DOC_FILETYPES.includes(file.type);
}

function preflightImageSize(){
  if(!window.uploadedImageSize){ // No image currently being displayed
    return;
  }
  $('.hullee-status-loader').css("display", "block");
  updateLoaderMessage('Validating print ready document...');  
  const preflightStatus = getPreflightStatus(window.uploadedImageSize);  
  displayPreflightMessage(preflightStatus);  
  toggleLoader();
}

async function displayPreview(file) {
  hidePreviewMessage();
  toggleLoader("Validating file type...");  
  if(!isValidFileType(file)){
    displayFiletypeMessage(file);
    toggleLoader();
    return;
  }  
  $(".uploader-prompt div").css("display", "none");
  updateLoaderMessage("Generating image preview...");

  const previewImageViewer = file.type.includes("application/pdf") ? new PdfViewer() : new ImageViewer();  
  
  const uploadedImageSize = await previewImageViewer.render(file); 
  window.previewCanvas = previewImageViewer.getCanvas();   
  displayReplaceButton(file);
  window.uploadedImageSize = uploadedImageSize;
  preflightImageSize();
 }

function toggleUploadModal(){
  $('.upload-modal').toggle();
}

function labelTransform(label){
  label = label.replace("Pick a", "").trim();
  return label.charAt(0).toUpperCase() + label.slice(1);
}

function setCanvasToSelectedSize(){
  // Set canvas and upload area dimention based from selected size
  const productSizeDetails = getProductSize();
  const canvasWidth = productSizeDetails?.canvas[0] || 420;
  const canvasHeight = productSizeDetails?.canvas[1] || 594;
  const aspectRatio = canvasWidth > canvasHeight ? 
    `${(canvasWidth / canvasHeight)} / 1 `: 
    `1 / ${(canvasHeight / canvasWidth)}` ;
  $('#upload-drop').css('width', canvasWidth);
  $('#upload-drop').css('height', canvasHeight);
  $('#upload-drop').css('aspect-ratio', aspectRatio);

  const canvasEl = getCanvasElement();
  canvasEl.width = canvasWidth;
  canvasEl.height = canvasHeight;
}

function displayUploadModal(){
  $('#upload-product-title').text($('.product__title h1').text());
  $('.price-tag-upload-modal').html($('.price__container .price-tag').html());    
  const productDetailsEl = $('.upload-modal-product-details');
  $(productDetailsEl).html("");
  $('hullee-variant-picker fieldset').toArray().forEach(fieldset => {
     const label = labelTransform($('legend', fieldset)?.html());
     let value = $('input[type="radio"]:checked', fieldset)?.val();
     if(label === 'Orientation'){
       value = 'Auto Orient';
     }
     $(productDetailsEl).append(`<legend class="form__label">${label}:</legend><span class="upload-modal-${label.replaceAll(" ","-")}-val">${value}</span>`);
  });  
  $(productDetailsEl).append('<br/><br/>');
  $(productDetailsEl).append($('.product-form__quantity').html());  
  $('.upload-modal-product-details .quantity__input').val($('.product-form__input .quantity__input').val());  
  toggleUploadModal();  
  $('.upload-modal-product-details .quantity__input').change(e => {
    const quantity =  $(e.target).val();
    $('.product-form__input input[name="quantity"]').val(quantity);
  });

  if(!window.uploadedImageSize){ // No image currently being displayed
    setCanvasToSelectedSize();
  }
  preflightImageSize();
}

function renderUploadModal(){  
  const template = `
    <div class="upload-modal" style="display:none;">
      <div class="upload-modal-window">        
        <div class="hullee-status-loader" style="display:none;">
          <div class="hullee-status-loader-ovelay">&nbsp;</div>
          <div class="hullee-status-loader-message-cont">
            <span class="hullee-status-loader-message"></span>
          </div>
        </div>
        <div class="upload-window-left">                    
          <div class="preview-message box" style="display:none">
            <div class="preview-message-header"></div>
            <div class="preview-message-content"></div>
            <button class="button button-small">Ok</button>
          </div>          
          <form id="fileUploaderForm">
            <input type="file"  accept="image/jpeg, image/png, image/bmp, application/pdf" name="uploader" id="uploader" style="display: none;">
          </form>        
          <div class="upload-area">            
            <canvas id="preview-canvas" style="display: none" width="420" height="594"></canvas>
            <label for="uploader" id="upload-drop">
              <div class="uploader-prompt">
                <div class="vertical-center-relative">
                  <img src="//cdn.shopify.com/s/files/1/0616/3529/7466/files/image_placeholder.png?v=1675408951" width="120px">
                  <p>Click here or drag your document to upload</p>
                  <p>pdf, jpeg/jpg, png, bmp</p>
                </div>
              </div>            
            </label>        
            <span class="file-name-display"></span>
            <label for="uploader" id="upload-replace-button" style="display:none">              
              <span class="button">Replace document</span>
            </label>            
          </div>
        </div>
        <div class="upload-window-right color-accent-1">
          <div class="upload-modal-header">
            <h3>Upload your own design</h3>
            <button class="upload-window-close">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                </path></svg>          
            </button>
          </div>          
          <div class="upload-modal-product">
            <div class="upload-modal-product-title">
              <h2 id="upload-product-title"></h2>
              <span class="price-tag-upload-modal price--large"></span>            
            </div>
            <div class="divider-container">
              <h3><span class="color-accent-1">Product Details</span></h3>
            </div>
            <div class="upload-modal-product-details">
              
            </div>
          </div>
          <div class="upload-modal-footer color-accent-2">
            <input type="button" id="upload-button" value="Add to cart" class="button button--primary vertical-center-relative" disabled>
          </div>
        </div>
      </div>
    </div>
  `
  $('body').append(template);
  uploadModalEl = $('upload-modal');  
  $('#upload-product-title').text($('.product__title h1').text());
  $('.price-tag-upload-modal').append($('.price__container .price-tag').html());
  const productDetailsEl =  $('.upload-modal-product-details');
}

$(document).ready(function(){
  if(!$('a.tiled-button[data-templateid="uploadYourOwn"]').length){ 
    return;
  }
  let file;

  renderUploadModal();
  const uploadDropEl = $('#upload-drop');

  uploadDropEl.on('drag dragstart dragend dragover dragenter dragleave drop', (e) => {
    e.preventDefault();
    e.stopPropagation();
  })
  .on('dragover dragenter', (e) => {
    uploadDropEl.addClass('drag-hover');
  })
  .on('dragleave dragend', (e) => {
    uploadDropEl.removeClass('drag-hover');
  })
  .on('drop', (e) => {
    uploadDropEl.removeClass('drag-hover');
    file = e.originalEvent?.dataTransfer?.files[0];                        
    
    if(file){      
      displayPreview(file);
    }
  });  

  $('#uploader').change(function(e) {    
    if(e.target.files.length){
      file = e.target.files[0];      
      displayPreview(file);
    }    
  });

  $('#upload-button').click(function(e){
    if(file){
      uploadModalAddToCart(file);
    }    
  });

  $('.upload-window-close').click(function(e){
    toggleUploadModal();
  });

  $('.preview-message button').click(e => {
    togglePreviewMessage();
  });

  
});